module.exports = __webpack_public_path__ + "static/media/earthBumpMap.0b514a39.jpeg";